<template>
  <b-container class="m-0 p-0">
    <b-form-group>
      <b-input-group :append="`${periode} dagen`">
        <date-input 
          :date="hinder.start"
          placeholder="Start werkzaamheden" 
          @date-changed="setHinderStart"
        />
        <date-input 
          :date="hinder.eind"
          placeholder="Einde werkzaamheden" 
          @date-changed="setHinderEind"
        />
      </b-input-group>
    </b-form-group>
  </b-container>
</template>
<script>
import DateInput from '../DateInput.vue'
import HinderInput from './HinderInput.vue'
export default {
    name: 'Periode',
    components: {DateInput, HinderInput},
    mixins: [],
    props: {
        hinder: {
            type: Object,
            default: () => {
                return {
                    start: null,
                    stop: null,
                }
            }
        }
    },
    data() {
        return  {
            standaardhinder: []
        }
    },
    computed: {
        periode: function() {
            if (!this.hinder.start) return 0
            if (!this.hinder.eind) return 0
            return -this.moment(this.hinder.start).diff(this.moment(this.hinder.eind), 'days') + 1
        },
    },
    watch: {},
    mounted () {
        
    },
    methods: {
        setHinderStart(start) {
  
            var startInput = start !== null ? start.toISOString() : null
            this.$set(this.hinder,'start',startInput)
            this.updatePeriode()
        },
        setHinderEind(eind) {

            var eindInput = eind !== null ? eind.toISOString() : null
            this.$set(this.hinder,'eind',eindInput)
            this.updatePeriode()
        },
        updatePeriode() {
            this.$emit('update-periode',this.periode);
        }
    },
          
}
</script>